namespace Ir.Components.Workbook.WorkbookInfo {
    interface IWorkbookInfoViewModel {
        tabPanelConfig: any,
        tabPanelComponent: DevExpress.ui.dxTabPanel
    }

    export function getViewModel(this: IWorkbookInfoViewModel, params: any) {
        this.tabPanelConfig = {
            dataSource: getDataSource(),
            selectedIndex: 0,
            width: '100%',
            height: '100%',
            animationEnabled: false,
            swipeEnabled: true,
            tabsPosition: "top",
            stylingMode: "secondary",
            iconPosition: "left",
            repaintChangesOnly: true,
            itemTitleTemplate: titleTemplate,
            onInitialized(e) {
                this.tabPanelComponent = e.component;
            }
        };
    }

    function titleTemplate(itemData, itemIndex, itemElement) {
        let $icon = $('<i>').text(itemData.icon);

        if (itemData.iconClass) {
            $icon.addClass(itemData.iconClass);
        }
        else {
            $icon.addClass("ms");
        }

        itemElement.append($icon);

        itemElement.append($('<span>').text(' ' + itemData.title));
    }

    function getDataSource() {
        let tabs = [
            {
                icon: 'info',
                iconClass: 'ms',
                title: 'Information',
                template: () => {
                    return getWorkbookInfo();
                },
            }
        ];

        //Only owner or administrators can see the user stats and workbook copies/original
        if (!loggedUser.permissions.workbooks() && (workbook.workbookConfig.userEditMode === WorkbookEditModeEnum.ViewOnly || workbook.workbookConfig.userEditMode === WorkbookEditModeEnum.Restricted)) {
            return tabs;
        }

        //***Is it necessary to change the tab name?
        let workbookCopiesData = {} as any;
        let wcTabName = "Workbook References";
        let o = {
            url: urlConfigs.tabs + "GetWorkbookCopies",
            data: {
                workbookId: workbook.workbookConfig.workbookId()
            },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data) {
            workbookCopiesData = data;
            if (workbookCopiesData.originalWorkbook.length > 0 && workbookCopiesData.workbookCopies.length === 0) {
                wcTabName = "Original Workbook";
            }
            else if (workbookCopiesData.workbookCopies.length > 0 && workbookCopiesData.originalWorkbook.length === 0) {
                wcTabName = "Workbook Copies";
            }
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get workbook copies";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };
        irGlobal.requestServer(o);
        //***

        tabs.push({
            icon: 'user_attributes',
            iconClass: 'ms',
            title: 'User Stats',
            template: () => {
                return getUserStatsTemplate();
            },
        });
        tabs.push({
            icon: 'content_copy',
            iconClass: 'ms',
            title: wcTabName,
            template: () => {
                let div = $("<div style='height: 100%'>");
                workbookCopies.setup(workbookCopiesData, div);
                return div;
            },
        });
        
        return tabs;
    }

    function getWorkbookInfo() {
        const div = $("<div>");
        let o = {
            url: urlConfigs.tabs + "GetWorkbookInfo",
            data: { workbookId: workbook.workbookConfig.workbookId() },
            dataType: "json",
            async: false,

        } as RequestServerParams;
        o.successFunction = function (data, e) {
            let $wbInfo = $($("#wbInfo").html());
            ko.applyBindings({
                creationDate: formatDateTime(data.creationDate),
                modificationDate: ko.observable(formatDateTime(data.modificationDate)),
                description: data.description,
                categoryName: data.categoryName,
                mappingName: data.mappingName,
                mappingDescription: data.mappingDescription,
                enableMultiTenant: ko.observable(data.enableMultiTenant),
                lastCompanySaved: data.lastCompanySaved,
                workbookName: workbook.workbookConfig.workbookName
            }, $wbInfo.get(0));
            $wbInfo.appendTo(div);

        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get workbook info";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return div;
    }

    function getUserStatsTemplate() {
        const gridView = $('<div />');

        let o = {
            url: urlConfigs.tabs + "GetWorkbookUserStats",
            data: { workbookId: workbook.workbookConfig.workbookId() },
            dataType: "json",
            async: false
        } as RequestServerParams;
        o.successFunction = function (data, e) {
            gridView.dxDataGrid({
                dataSource: data.dataSource,
                height: "100%",
                columns: [
                    { dataField: "userId", caption: "User Id", width: isMobile() ? undefined : 80 },
                    { dataField: "userName", caption: "User Name" },
                    { dataField: "counter", caption: "Counter", width: isMobile() ? undefined : 80 },
                    {
                        dataField: "lastAccess",
                        dataType: "datetime",
                        caption: "Last Access",
                        customizeText(cellInfo) {
                            return formatDateTime(cellInfo.value)
                        },
                        sortOrder: 'desc',
                        width: isMobile() ? undefined : 150
                    }
                ]
            });
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = "Failed to get user stats from workbook";
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return gridView;
    }
}